var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.5C6.55228 5.5 7 5.94772 7 6.5V7.5H5V6.5C5 5.94772 5.44772 5.5 6 5.5ZM8 7.5763V6.5C8 5.39543 7.10457 4.5 6 4.5C4.89543 4.5 4 5.39543 4 6.5V7.5763C3.46076 7.74248 3 8.17317 3 8.8V11.2C3 12.0163 3.78146 12.5 4.5 12.5H7.5C8.21854 12.5 9 12.0163 9 11.2V8.8C9 8.17317 8.53924 7.74248 8 7.5763Z",
    fill: "#BCBDBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5C0.895431 0.5 0 1.39543 0 2.5V14.5C0 15.6046 0.895431 16.5 2 16.5H10C11.1046 16.5 12 15.6046 12 14.5V2.5C12 1.39543 11.1046 0.5 10 0.5H2ZM2 1.5H10C10.5523 1.5 11 1.94772 11 2.5V14.5C11 15.0523 10.5523 15.5 10 15.5H2C1.44772 15.5 1 15.0523 1 14.5V2.5C1 1.94772 1.44772 1.5 2 1.5Z",
    fill: "#BCBDBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.9e76df3926f33961b21f9e5769afdfcc.svg";
export { ForwardRef as ReactComponent };